import JQuery from 'jquery'

let $ = JQuery
import {getURLBlob, isMobile} from "@/helps/util"

export function impressao(fileURL, tipo) {
    return new Promise((resolve) => {
        getURLBlob(fileURL).then(response => {
            if (tipo === 'P' && !isMobile()) {
                let pdf = '<iframe src="' + response + '" name="print_frame" style="display: none" id="print_frame"></iframe>';
                $("#print_frame").detach();
                $(document.body).append(pdf);
                window.frames["print_frame"].focus();
                window.frames["print_frame"].print();
            } else {
                window.open(response, '_blank');
            }
            resolve(true)
        })
    })
}

export function urlTemp(fileURL) {
    return new Promise((resolve, reject) => {
        getURLBlob(fileURL).then(response => {
            resolve(response)
        }).catch(() => {
            reject("Erro ao gerar Blob nota")
        })
    })
}